import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../app/store';

const PublicRoute: React.FC = () => {
  const user = useSelector((state: RootState) => state.auth.user);
  return user ? <Navigate to='/dashboard' replace /> : <Outlet />;
};

export default PublicRoute;